'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.initDefault = initDefault;
exports.destroy = destroy;
exports.setPage = setPage;
exports.setSort = setSort;
exports.setFilter = setFilter;
exports.setFilterLive = setFilterLive;
exports.load = load;
exports.addSelectedRows = addSelectedRows;
exports.removeSelectedRows = removeSelectedRows;
exports.expandRows = expandRows;
exports.collapseRows = collapseRows;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var INIT_DEFAULT = 'datagrid/initDefault';
var DESTROY = 'datagrid/destroy';

var LOAD = 'datagrid/LOAD';
var LOAD_SUCCESS = 'datagrid/LOAD_SUCCESS';
var LOAD_FAIL = 'datagrid/LOAD_FAIL';

var SET_PAGE = 'datagrid/setPage';
var SET_SORT = 'datagrid/setSort';
var SET_FILTER = 'datagrid/setFilter';
var SET_FILTER_LIVE = 'datagrid/setFilterLive';

var ADD_SELECTED_ROWS = 'datagrid/AddSelectedRows';
var REMOVE_SELECTED_ROWS = 'datagrid/RemoveSelectedRows';

var EXPAND_ROWS = 'datagrid/ExpandRows';
var COLLAPSE_ROWS = 'datagrid/CollapseRows';

var initialState = _immutable2['default'].Map();

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case INIT_DEFAULT:
			return state.set(action.id, _immutable2['default'].fromJS(action.state));

		case DESTROY:
			return state['delete'](action.id);

		case LOAD:
			return state.setIn([action.id, 'pending'], true);

		case LOAD_SUCCESS:
			return state.setIn([action.id, 'pending'], false).setIn([action.id, 'count'], action.result.count).setIn([action.id, 'items'], _immutable2['default'].fromJS(action.result.items)).setIn([action.id, 'summary'], _immutable2['default'].fromJS(action.result.summary));

		case SET_PAGE:
			return state.setIn([action.id, 'page'], action.page);

		case SET_SORT:
			return state.setIn([action.id, 'sort'], _immutable2['default'].fromJS(action.sort));

		case SET_FILTER:
			return state.setIn([action.id, 'page'], 1).setIn([action.id, '_filter'], action.value).setIn([action.id, 'filter'], action.value);

		case SET_FILTER_LIVE:
			return state.setIn([action.id, '_filter'], action.value);

		case ADD_SELECTED_ROWS:
			var selected = state.getIn([action.id, 'selected']);
			if (!selected) {
				selected = _immutable2['default'].List();
			}
			action.ids.forEach(function (id) {
				if (selected.indexOf(id) == -1) {
					selected = selected.push(id);
				}
			});
			return state.setIn([action.id, 'selected'], selected);

		case REMOVE_SELECTED_ROWS:
			var selected = state.getIn([action.id, 'selected']);
			if (!selected) {
				selected = _immutable2['default'].List();
			}
			action.ids.forEach(function (id) {
				var i = selected.indexOf(id);
				if (i != -1) {
					selected = selected.splice(i, 1);
				}
			});
			return state.setIn([action.id, 'selected'], selected);

		case EXPAND_ROWS:
			var list = state.getIn([action.id, 'expanded']);
			if (!list) {
				list = _immutable2['default'].List();
			}
			action.ids.forEach(function (id) {
				if (list.indexOf(id) == -1) {
					list = list.push(id);
				}
			});
			return state.setIn([action.id, 'expanded'], list);

		case COLLAPSE_ROWS:
			var list = state.getIn([action.id, 'expanded']);
			if (!list) {
				list = _immutable2['default'].List();
			}
			action.ids.forEach(function (id) {
				var i = list.indexOf(id);
				if (i != -1) {
					list = list.splice(i, 1);
				}
			});
			return state.setIn([action.id, 'expanded'], list);

		default:
			return state;
	}
}

function initDefault(id, state) {
	return {
		type: INIT_DEFAULT,
		id: id,
		state: state
	};
}

function destroy(id) {
	return {
		type: DESTROY,
		id: id
	};
}

function setPage(id, page) {
	return {
		type: SET_PAGE,
		id: id,
		page: page
	};
}

function setSort(id, sort) {
	return {
		type: SET_SORT,
		id: id,
		sort: sort
	};
}

function setFilter(id, value) {
	return {
		type: SET_FILTER,
		id: id,
		value: value
	};
}

function setFilterLive(id, value) {
	return {
		type: SET_FILTER_LIVE,
		id: id,
		value: value
	};
}

function load(id, api, dgState, limit) {
	var saveState = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];

	return {
		types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
		id: id,
		promise: function promise(client) {
			return client.call(api, { qo: {
					page: dgState.page,
					sort: dgState.sort,
					limit: limit,
					filter: dgState.filter
				}, save: saveState });
		}
	};
}

function addSelectedRows(id, ids) {
	return {
		type: ADD_SELECTED_ROWS,
		id: id,
		ids: ids
	};
}

function removeSelectedRows(id, ids) {
	return {
		type: REMOVE_SELECTED_ROWS,
		id: id,
		ids: ids
	};
}

function expandRows(id, ids) {
	return {
		type: EXPAND_ROWS,
		id: id,
		ids: ids
	};
}

function collapseRows(id, ids) {
	return {
		type: COLLAPSE_ROWS,
		id: id,
		ids: ids
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-datagrid/src/reducer.js
 ** module id = 244
 ** module chunks = 1
 **/